import React from "react";

export default function Divider({ vertical, className }) {
	return <div className={`${vertical ? "h-full" : "w-full"} border-b-[1px] border-gray-300 ${className}`}></div>;
}
